<app-alert></app-alert>
<app-loading-modal></app-loading-modal>

<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Disparos</p>
      <h1 class="text-2xl font-semibold leading-tight">Histórico de disparos</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Acompanhe os disparos realizados, acesse relatórios e reprograme envios rapidamente.
      </p>
    </div>
    <div class="grid grid-cols-2 gap-3 text-sm md:grid-cols-2">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Total de disparos</p>
        <strong class="text-lg">{{ listFires.length || 0 }}</strong>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Ações rápidas</p>
        <button
          type="button"
          class="mt-2 inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-2 text-xs font-semibold text-white shadow transition hover:bg-primary-hover"
          (click)="openModalNewFire()">
          <mat-icon>add</mat-icon>
          Novo disparo
        </button>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-3 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div class="flex items-center gap-2 text-sm text-dark-color">
        <mat-icon>history</mat-icon>
        <span>Lista de disparos registrados.</span>
      </div>
      <button
        type="button"
        class="inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-primary-hover"
        (click)="openModalNewFire()">
        <mat-icon>add</mat-icon>
        Novo disparo
      </button>
    </div>

    <div class="overflow-hidden rounded-xl border border-border-color">
      <table class="min-w-full divide-y divide-border-color text-sm">
        <thead class="bg-light-color/60">
          <tr>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Id</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Campanha</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Tipo</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Data e Hora</th>
            <th class="px-4 py-3 text-right font-semibold text-dark-color">Opções</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-border-color">
          <tr *ngFor="let disparo of listFires" class="hover:bg-light-color/60 transition">
            <td class="px-4 py-3 text-dark-color font-semibold">
              <button
                type="button"
                class="text-primary-color transition hover:underline"
                title="Copiar ID do disparo"
                (click)="copyDisparoId(disparo.iddisparo)">
                #{{ disparo.iddisparo }}
              </button>
            </td>
            <td class="px-4 py-3 text-dark-color">
              <span class="block max-w-xs truncate" [title]="disparo.nomecampanha">{{ disparo.nomecampanha | truncateString:40 }}</span>
            </td>
            <td class="px-4 py-3 text-dark-color">{{ disparo.tipo }}</td>
            <td class="px-4 py-3 text-dark-color">{{ disparo.createdAt | date:'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="px-4 py-3">
              <div class="flex justify-end gap-2">
                <a
                  routerLink="/app/disparo/{{disparo.iddisparo}}"
                  target="_blank"
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-green-700 transition hover:border-primary-color hover:text-primary-color"
                  title="Visualizar Disparo">
                  <mat-icon>visibility</mat-icon>
                </a>
                <button
                  type="button"
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-blue-700 transition hover:border-primary-color hover:text-primary-color"
                  title="Baixar Relatório"
                  (click)="handleExportReport(disparo.iddisparo)">
                  <mat-icon>download</mat-icon>
                </button>
                <button
                  type="button"
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-yellow-700 transition hover:border-primary-color hover:text-primary-color"
                  title="Reenviar Disparo"
                  (click)="handleResendDisparo(disparo.iddisparo)">
                  <mat-icon>reply</mat-icon>
                </button>
                <button
                  type="button"
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-red-700 transition hover:border-primary-hover hover:text-primary-hover"
                  title="Parar Disparo"
                  (click)="handleStopDisparo(disparo.iddisparo)">
                  <mat-icon>cancel</mat-icon>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!listFires.length">
            <td colspan="5" class="px-4 py-6 text-center text-dark-color/70">
              Nenhum disparo registrado.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex justify-center items-center gap-2 mt-4">
      <button
        class="px-4 py-2 rounded-base border border-border-color bg-white text-dark-color transition hover:border-primary-color disabled:opacity-60"
        (click)="previousPage()"
        [disabled]="page === 1">
        &laquo;
      </button>

      <button
        class="px-4 py-2 rounded-base border border-border-color bg-white text-dark-color transition hover:border-primary-color"
        (click)="nextPage()">
        &raquo;
      </button>
    </div>
  </section>
</div>

<ng-container *ngIf="modalNewFire">
  <div class="fixed inset-0 z-50 flex items-center justify-center px-4">
    <div class="fixed inset-0 bg-black/60 backdrop-blur-sm" (click)="closeModalNewFire()"></div>

    <div class="relative w-full max-w-3xl rounded-2xl border border-border-color bg-white p-6 shadow-2xl">
      <div class="flex items-start justify-between border-b border-border-color pb-4">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Novo disparo</p>
          <h3 class="text-lg font-semibold text-dark-color">Escolha o tipo de fila</h3>
          <p class="text-sm text-dark-color/70">Selecione como deseja enviar e escolha o formato para iniciar.</p>
        </div>
        <button
          type="button"
          class="rounded-lg p-2 text-dark-color/70 hover:bg-light-color/70"
          (click)="closeModalNewFire()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2">
        <button
          type="button"
          (click)="handleSelectTypeFire('WAMD')"
          [ngClass]="typeFire === 'WAMD' ? 'ring-2 ring-primary-color' : ''"
          class="flex flex-col gap-2 rounded-xl border border-border-color bg-light-color/60 px-4 py-4 text-left transition hover:border-primary-color hover:bg-light-color">
          <div class="flex items-center gap-2">
            <mat-icon>send</mat-icon>
            <h4 class="text-base font-semibold text-dark-color m-0">Normal</h4>
          </div>
          <p class="m-0 text-sm text-dark-color/70">Realize o seu disparo pelas filas WAMD.</p>
        </button>

        <button
          type="button"
          (click)="handleSelectTypeFire('APIOFICIAL')"
          [ngClass]="typeFire === 'APIOFICIAL' ? 'ring-2 ring-primary-color' : ''"
          class="flex flex-col gap-2 rounded-xl border border-border-color bg-light-color/60 px-4 py-4 text-left transition hover:border-primary-color hover:bg-light-color">
          <div class="flex items-center gap-2">
            <mat-icon>api</mat-icon>
            <h4 class="text-base font-semibold text-dark-color m-0">API Oficial</h4>
          </div>
          <p class="m-0 text-sm text-dark-color/70">Realize o seu disparo pelas filas WA Cloud API.</p>
        </button>
      </div>

      <ng-container *ngIf="selectedFire">
        <div class="mt-6 flex flex-col gap-2 md:flex-row md:items-center md:justify-end">
          <button
            type="button"
            class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover"
            (click)="handleSelectTypeForm('csv')">
            Disparar via CSV
          </button>
          <button
            type="button"
            class="rounded-base bg-dark-color px-4 py-2 text-sm font-semibold text-white transition hover:border-primary-color disabled:cursor-not-allowed disabled:bg-gray-400"
            [disabled]="typeFire === 'APIOFICIAL'"
            title="Disponível apenas para disparos WAMD"
            (click)="handleSelectTypeForm('queue')">
            Disparar via Lista
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>


<ng-container *ngIf="selectedTypeForm === 'csv-WAMD'">
  <app-fire-csv (closeModal)="closeModalConfiguration($event)"></app-fire-csv>
</ng-container>

<ng-container *ngIf="selectedTypeForm === 'queue-WAMD'">
  <app-fire-queue (closeModal)="closeModalConfiguration($event)"></app-fire-queue>
</ng-container>

<ng-container *ngIf="selectedTypeForm === 'csv-APIOFICIAL'">
  <app-fire-oficial-csv (closeModal)="closeModalConfiguration($event)"></app-fire-oficial-csv>
</ng-container>

<ng-container *ngIf="selectedTypeForm === 'queue-APIOFICIAL'">
  <app-fire-oficial-lista (closeModal)="closeModalConfiguration($event)"></app-fire-oficial-lista>
</ng-container>
